import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { DataBuild } from 'src/app/models/data-build';

@Component({
    selector: 'app-build-detail-widget',
    templateUrl: './build-detail-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './build-detail-widget.component.scss'],
    standalone: false
})
export class BuildDetailWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Input() isNew: boolean = false;
  @Input() rdsName: string;
  @Input() runId: number;
  @Input() username: string;
  @Input() isArchived: boolean;
  @Input() cloneSchema: any = null;

  @Output() onAsset = new EventEmitter<{ parentId: string; assetName: string }>();
  @Output() onTerminal = new EventEmitter<{ parentId: string; command: string; title: string }>();
  @Output() onLog = new EventEmitter<{ parentId: string; runId: number; rdsName: string; isArchived: boolean }>();
  @Output() onBuildStarted = new EventEmitter<{ parentId: string; build: DataBuild }>();

  public title: string = 'Build';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.title = this.isNew ? 'New Build' : 'Build';
  }

  onOpenAsset($event: { assetName: string }) {
    this.onAsset.emit({ parentId: this.id, assetName: $event.assetName });
  }

  onOpenTerminal($event: { command: string; title: string }) {
    this.onTerminal.emit({ parentId: this.id, ...$event });
  }

  onViewLog($event: { runId: number; rdsName: string; isArchived: boolean }) {
    this.onLog.emit({ parentId: this.id, ...$event });
  }

  onSchemaLaunch($event: { build: DataBuild }) {
    this.onBuildStarted.emit({ parentId: this.id, build: $event.build });
  }
}
